import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  envName: 'test',
  apiBaseUrl: 'https://zanxcportaldemo.egoz.go.tz/',
  apiUrl: 'https://zanxcportaldemo.egoz.go.tz/api/v1',
  apiV1Url: 'https://zanxcportaldemo.egoz.go.tz/api/v1',
  centralServerUrl: 'https://zanxccsdemo.egoz.go.tz:4000/api/v1',
  zpdpcUrl: 'https://test-zpdpc.go.tz/api/v1',
  auth: {
    tokenKey: 'zanx_token_test',
    refreshTokenKey: 'zanx_refresh_token_test',
    userKey: 'zanx_user_test',
    personaKey: 'zanx_persona_test',
    sessionTimeoutMs: 600000,
    idleTimeoutMinutes: 5 // Hardened idle timeout: 5 minutes
  },
  theme: {
    storageKey: 'zanx_theme',
    defaultTheme: 'dark'
  },
  ui: {
    appTitle: 'Zan-X Data Exchange & Consent Portal (QA / Test)',
    appVersion: '1.0.0-rc',
    authorityName: 'e-Government Authority of Zanzibar (eGAZ)',
    pageSize: 15,
    toastDurationMs: 4500,
    enableDebugLogging: true
  }
};
